"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NibbyHappyGraphicIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const get_size_1 = require("../get-size");
const use_mesh_selector_1 = require("../../mesh/use-mesh-selector");
const NibbyHappyGraphicIcon = _a => {
  var {
      size = "md",
      fill = "currentColor"
    } = _a,
    props = __rest(_a, ["size", "fill"]);
  const fillColor = (0, use_mesh_selector_1.useMeshSelector)(fill);
  const sizeValue = (0, get_size_1.getSize)(size);
  return (0, jsx_runtime_1.jsxs)("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: sizeValue,
    height: sizeValue,
    fill: "none",
    viewBox: "0 0 33 33"
  }, props, {
    children: [(0, jsx_runtime_1.jsx)("path", {
      fill: fillColor,
      fillRule: "evenodd",
      d: "M6.628 26.434H3.223A2.723 2.723 0 0 1 .5 23.71V3.287A2.723 2.723 0 0 1 3.223.562h26.554A2.723 2.723 0 0 1 32.5 3.287V23.71a2.723 2.723 0 0 1-2.723 2.723H15.706l-7.989 5.991a.68.68 0 0 1-1.09-.545v-5.446zm8.442-1.226a.68.68 0 0 1 .409-.136h14.298c.752 0 1.361-.61 1.361-1.361V3.285c0-.752-.61-1.362-1.361-1.362H3.223c-.752 0-1.361.61-1.361 1.362V23.71c0 .752.61 1.361 1.361 1.361H7.31a.68.68 0 0 1 .68.681v4.766z",
      clipRule: "evenodd"
    }), (0, jsx_runtime_1.jsx)("path", {
      fill: fillColor,
      fillRule: "evenodd",
      d: "M13.888 9.794a3.724 3.724 0 0 0-6.685 0 .68.68 0 1 0 1.222.6 2.363 2.363 0 0 1 4.24 0 .681.681 0 1 0 1.223-.6m12.247 0a3.724 3.724 0 0 0-6.685 0 .68.68 0 0 0 1.222.6 2.363 2.363 0 0 1 4.24 0 .681.681 0 1 0 1.223-.6m-15.197 8.292a8.507 8.507 0 0 0 11.462 0 .681.681 0 0 0-.917-1.006 7.145 7.145 0 0 1-9.628 0 .682.682 0 0 0-1.075.792.7.7 0 0 0 .158.214",
      clipRule: "evenodd"
    })]
  }));
};
exports.NibbyHappyGraphicIcon = NibbyHappyGraphicIcon;